import { useAppContext } from "app/AppContext";
import React, { useEffect } from "react";
import ConsultaVisitasRelatorios from "./components/ConsultaVisitasRelatorios";
import { useNavigate } from "react-router-dom";
import LaudoVisitaForm from "entity/LaudoVisita/components/LaudoVisitaForm";
import LaudoVisitaConsultaRelatorios from "entity/LaudoVisita/components/LaudoVisitaConsultaRelatorios";

export default function RoutesMenusCliente() {
    const navigate = useNavigate();
    const { addMenu, addRoute, removeMenusRoutes } = useAppContext();

    useEffect(() => {
        addMenu({
            uid: "visita",
            text: "Nova Visita",
            sequence: "111112",
            iconName: "Queue",
            action: () => {
                navigate("/visita");
            },
        });
        addRoute({ uid: "visita", title: "Nova Visita", route: "visita", element: <LaudoVisitaForm /> });

        addMenu({
            uid: "ConsultaVisitasRelatorios",
            text: "Consulta de Visitas",
            sequence: "111113",
            iconName: "FindInPage",
            action: () => {
                navigate("/ConsultaVisitasRelatorios");
            },
        });
        addRoute({
            uid: "ConsultaVisitasRelatorios",
            title: "Consulta de Visitas",
            route: "ConsultaVisitasRelatorios",
            element: <ConsultaVisitasRelatorios />,
        });

        addMenu({
            uid: "relatorios",
            text: "Relatórios",
            sequence: "111114",
            iconName: "Print",
            action: () => {
                navigate("/Relatorios");
            },
        });
        addRoute({
            uid: "relatorios",
            title: "Relatórios",
            route: "Relatorios",
            element: <LaudoVisitaConsultaRelatorios />,
        });

        return () => {
            removeMenusRoutes(["visita", "ConsultaVisitasRelatorios", "relatorios"]);
        };
    }, [addMenu, addRoute, navigate, removeMenusRoutes]);

    return <></>;
}
